module.exports = __webpack_public_path__ + "static/media/CooperLtBTLight.cfaf0228.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/cooper/CooperLtBTLight.woff
// module id = 166
// module chunks = 56